import React from 'react';
import { motion } from 'framer-motion';
const items = [{
  stat: '5 days',
  desc: 'From engagement to staff access',
  client: 'Bowen Buchbinder Vilensky'
}, {
  stat: 'Under 45 days',
  desc: 'Cloud transition completed',
  client: 'Harrier Human Capital'
}, {
  stat: 'Under 2 hrs',
  desc: 'Reported user downtime during deployment',
  client: 'Harrier Human Capital'
}, {
  stat: 'Under 12 mths',
  desc: 'Reported return on investment',
  client: 'Williams & Hughes'
}];
export function OutcomesRibbon() {
  return <section className="w-full bg-navy" aria-label="Published project outcomes" data-id="element-385">
      <div className="mx-auto max-w-content px-5 py-14 md:px-8 md:py-16" data-id="element-386">
        <div className="flex items-center justify-between gap-4" data-id="element-387">
          <p className="text-[13px] font-bold uppercase tracking-[0.14em] text-ct-light" data-id="element-388">
            Published CT Group project outcomes
          </p>
          <span className="hidden text-[12px] text-white/40 sm:block" data-id="element-389">
            Historical case-study results. Individual outcomes vary.
          </span>
        </div>

        <div className="mt-8 grid grid-cols-2 items-stretch gap-4 lg:grid-cols-4" data-id="element-390">
          {items.map((it, i) => <motion.div key={it.stat + it.client} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="flex h-full flex-col rounded-card border border-white/10 bg-white/[0.04] p-5 backdrop-blur-sm" data-id="element-391">
              <p className="font-display text-[28px] font-black leading-none tracking-tight text-white md:text-[34px]" data-id="element-392">
                {it.stat}
              </p>
              <p className="mt-3 text-[13.5px] leading-snug text-white/75" data-id="element-393">
                {it.desc}
              </p>
              <p className="mt-auto border-t border-white/10 pt-3 text-[11.5px] font-semibold uppercase tracking-wide text-ct-light/80" data-id="element-394">
                {it.client}
              </p>
            </motion.div>)}
        </div>

        <p className="mt-6 text-[12px] text-white/40 sm:hidden" data-id="element-395">
          Historical case-study results. Individual outcomes vary.
        </p>
      </div>
    </section>;
}